const colors = {
  // "#77C5D5"
  color1: {
    primary: "#2E7A99",
    secondary: ["#B1E4E3", "#88DBDF"],
  },
  color2: {
    primary: "#FBD872",
    secondary: ["#F8E08E", "#F3DD6D"],
  },
  color3: {
    primary: "#6DCDB8",
    secondary: ["#00AB84", "#00A499"],
  },
  color4: {
    primary: "#FF5C39",
    secondary: ["#FF6A39", "#FF8674"],
  },
  color5: {
    primary: "#000000",
    secondary: ["#1E22AA", "#485CC7"],
  },
  color6: {
    primary: "#FFFFFF",
    seconadary: ["#F277C6", "#F99FC9"],
  },
  logo: ["#FFE67F", "#B8E3EC", "#73CEE5"],
};

export { colors };
